module.exports = __webpack_public_path__ + "static/img/28.37d24276.jpg";